import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Container, Dropdown, Nav, Table } from 'react-bootstrap'
import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { Pagination } from '../../../CommonComponents/Pagination'
import { checkTwilioIntegration, maskContactNumber, navigateToCrmDetail } from '../../../Utils/helpers/commonhelper'
import imgs from "../../../Utils/assets/img/faces/5.jpg"
import useLocalStorageState from 'use-local-storage-state'
import { toast } from 'sonner'
// import { CPopover } from '@coreui/react'
import TwilioIntegrationForm from '../../ivr/TwilioIntegrationForm'
import GlobalCallModal from '../../ivr/GlobalCallModal'
import { useLocation, useNavigate } from 'react-router-dom'
import { TableWrapper } from '../../../CommonComponents/TableWrapper'
import { ContactTooltip } from './ContactTooltip'

export const ContactTableListing = ({
    isLoading,
    hasDataToDisplay,
    dataToDisplay,
    handlePageChange,
    columns,
    // setContactId,
    // setShowContactDetailsCanvas,
    setConfirmDeleteId,
    setShowDeleteModal,
    limit,
    setLimit,
    offset,
    setOffset,
    totalItems,
    displayStartItem,
    displayEndItem,
    effectivePageCount,
    setShowId,
    currPageItems
}) => {

    let start = offset * limit + 1
    const [customer, setCustomer] = useLocalStorageState('customer')
    const navigate = useNavigate()
    const location = useLocation()

    // token obj
    const headers = {
        Authorization: customer?.token?.authorization,
        Authentication: customer?.token?.authentication,
    }
    const extras = { customer, setCustomer, rf: headers.Authentication, navigate }
    const [PERMISSION, _] = useLocalStorageState('permission')

    const contactPermission = PERMISSION?.contact;

    //open row is meant for to track which row dropdown is currently open
    const [openRow, setOpenRow] = useState(null)

    // dialer states for twillio
    const [twilioCallClicked, setTwillioCallClicked] = useState(false)
    const [module_id, setModuleId] = useState(null)
    const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
    const [globalDiller, setGlobalDiller] = useState(false);
    const [showtwilioModal, setShowTwilioModal] = useState(false);
    const [callingTo, setCallingTo] = useState(null)

    const visibleColumnLabels = columns
    const getColumnData = (contact, columnLabel, index) => {
        const columnMap = {
            '#': index,
            'Name': contact.contact_full_name,
            'Email': contact.email,
            'Owner': contact.owner_name || "-",
            'Report To': contact.report_to || "-",
            'Visible To': contact.visible_to || "-",
            'Company Name': contact.company_name || "-",
            'Designation': contact.designation || "-",
            'Department': contact.department || "-",
            'Decision Maker': contact.decision_maker || "-",
            'Address': contact.address || "-",
            'City': contact.city_name !== null ? contact.city_name : "-",
            'State': contact.state_name || "-",
            'Country': contact.country_name || "-",
            'Zipcode': contact.zipcode || "-",
            'Lead Source': contact.source_title,
            'Tags': contact.tag ? JSON.parse(contact.tag).join(", ") : "",
            'Notes': contact.note
        };

        return columnMap[columnLabel] || "-";
    };
    // Add this function to get special styling for specific columns
    // we want a 3 dots at the end of the name if the name is too long
    // but the 3 dots are not visible at end of the name

    const getColumnStyle = (columnLabel, contact) => {
        switch (columnLabel) {
            case 'Name':
                return {
                    overflow: "hidden",
                    maxWidth: '21ch',
                    width: '21ch',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    cursor: "pointer",
                    textTransform: "capitalize",
                    color: "inherit",
                    fontWeight: 600,

                };
            case 'Mobile':
            case 'Email':
                return { color: "#2184ff" };
            case 'Notes':
                return {
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                };
            default:
                return {};
        }
    };
    const getRandomOwnerColor = () => {
        const colors = [
            { bg: "#E8F4FD", text: "#0B5ED7" },
            { bg: "#E8EAF6", text: "#3F51B5" },
            { bg: "#F3E5F5", text: "#9C27B0" },
            { bg: "#E0F2F1", text: "#009688" },
            { bg: "#E8EAF6", text: "#5C6BC0" },
            { bg: "#FBE9E7", text: "#D84315" }
        ];

        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
    };
    const getColumnContent = (contact, columnLabel, index) => {
        const data = getColumnData(contact, columnLabel, index);

        switch (columnLabel) {
            case "Mobile":
                return <ContactTooltip
                    contact={contact}
                    module_name={'contact'}
                    data={contact?.phone}
                    customer={customer}
                />
            case "Email":
                return (
                    <p style={{ color: "black" }}>
                        <i className="fa-solid fa-envelope" style={{ color: "black" }}></i> {data}
                    </p>
                );
            case "Company Name":
                return (
                    <span style={{ color: "black" }}>
                        {data}
                    </span>
                );
            case "Owner":
                const ownerColors = getRandomOwnerColor(contact.owner_name);
                return (
                    <div
                        style={{
                            textTransform: "capitalize",
                            backgroundColor: ownerColors.bg,
                            color: ownerColors.text,
                            borderRadius: "12px",
                            padding: "0px 6px",
                            textAlign: "center",
                            width: 'max-content'
                        }}
                    >
                        {contact.owner_name || "-"}
                    </div>
                )
            case "Name":
                return (
                    <div className="d-flex gap-1 align-items-center" style={{ maxWidth: "21ch" }}>
                        <div style={{
                            height: "25px",
                            width: "25px",
                            display: "inline-block",
                            flex: "0 0 25px"
                        }}>
                            <img src={imgs} alt="contact Image"
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    flexShrink: 0
                                }} />
                        </div>
                        <span style={{
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>
                            {contact.contact_full_name}
                        </span>
                    </div>
                )
            case "Notes":
                // Add ellipsis for long notes
                return (
                    <div
                        style={{
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                        title={data} // Show full text on hover
                    >
                        {data}
                    </div>
                );
            default:
                return data;
        }
    };


    const handleGlobalCallChange = () => {
        setGlobalDiller(false);
        setModuleId(null)
        setTwillioCallClicked(false)
    };
    useEffect(() => {
        if (!twilioCallClicked) {
            return
        }
        const checkTwilio = async () => {
            if (isCheckingTwilio) return;
            setIsCheckingTwilio(true);
            try {
                const res = await checkTwilioIntegration(customer?.customer_details?.customer_id, headers, { customer, setCustomer, rf: headers.Authentication, navigate });
                if (res?.status === "fail" || res?.success === false) {
                    setShowTwilioModal(true);
                }
                if (res?.status === "success") {
                    setGlobalDiller(true);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsCheckingTwilio(false);
            }
        };

        checkTwilio();
    }, [twilioCallClicked]);

    const tableHeader = () => (<thead style={{ zIndex: 10 }}>
        <tr style={{ textAlign: "start" }}>
            {visibleColumnLabels.map((columnLabel) => {
                return (
                    <React.Fragment key={columnLabel}>
                        {columnLabel !== "Visible To" && (
                            <th >
                                {columnLabel}{" "}
                                <i className="fa-solid fa-sort" />
                            </th>
                        )}
                    </React.Fragment>
                )
            })}
            <th></th>
        </tr>
    </thead>)

    const tableBody = () => (dataToDisplay?.map((contact, contactIndex) => {
        return (
            <React.Fragment key={contact.id}>
                <tr
                    style={{
                        marginTop: "10px",
                        marginBottom: "10px",

                    }}
                >
                    {visibleColumnLabels?.map(
                        (columnLabel, colIndex) => {
                            return (
                                <React.Fragment key={colIndex}>
                                    {columnLabel !== "Visible To" && (
                                        <td
                                            style={getColumnStyle(
                                                columnLabel,
                                                contact,
                                            )}
                                            onClick={
                                                columnLabel === "Name"
                                                    ? () => {
                                                        // setContactId(contact.id)
                                                        // setShowContactDetailsCanvas(
                                                        //     true,
                                                        // )
                                                        navigateToCrmDetail(
                                                            navigate,
                                                            location,
                                                            `/contactDetails?currContactId=${contact?.id}`,
                                                            {
                                                                contactIds: dataToDisplay.map(({ id }) => id),
                                                            },
                                                        )
                                                    }
                                                    : undefined
                                            }
                                        >
                                            {getColumnContent(
                                                contact,
                                                columnLabel,
                                                start + contactIndex,
                                            )}
                                        </td>
                                    )}
                                </React.Fragment>
                            )
                        },
                    )}
                    <td
                        className="lastactionTd"
                        style={{
                            "--pad": "10px",
                            paddingRight: "var(--pad) !important",
                            paddingLeft: "var(--pad) !important",
                            zIndex:
                                openRow === contact.id ? 11 : "auto",
                        }}
                    >
                        <div className="endTdDiv">
                            <Dropdown
                                as="div"
                                className="dropdownsWithoutToggle"
                                onToggle={(isOpen) =>
                                    setOpenRow(isOpen ? contact.id : null)
                                }
                            >
                                <Dropdown.Toggle
                                    as={Nav.Link}
                                    className="header-link"
                                >
                                    <FontAwesomeIcon
                                        icon={faEllipsisVertical}
                                        style={{
                                            fontSize: "15px",
                                            width: "20px",
                                            color: "#536485",
                                        }}
                                    />
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    align={"end"}
                                    style={{
                                        width: "8rem",
                                        inset: "0px auto auto 0px",
                                        boxShadow:
                                            "rgb(215, 215, 215) 0px 0px 15px",
                                        position: "absolute",
                                        marginTop: "-22px",
                                        marginRight: "25px",
                                        minWidth: "3rem",
                                    }}
                                >
                                    <Dropdown.Item
                                        style={{
                                            fontSize: "12px",
                                            padding: "4px 21px",
                                        }}
                                        className="d-flex align-items-center btn"
                                        onClick={(e) => {
                                            if (!contactPermission?.isEdit) {
                                                toast.warning(
                                                    "You are not authorised for this action!",
                                                )
                                                return
                                            }
                                            e.stopPropagation()
                                            setShowId(contact.id)
                                        }}
                                    >
                                        Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        style={{
                                            fontSize: "12px",
                                            padding: "4px 21px",
                                        }}
                                        className="d-flex align-items-center btn"
                                        onClick={(e) => {
                                            if (!contactPermission?.isDelete) {
                                                toast.warning(
                                                    "You are not authorised for this action!",
                                                )
                                                return
                                            }
                                            e.stopPropagation()
                                            setShowDeleteModal(true)
                                            setConfirmDeleteId(contact.id)
                                        }}
                                    >
                                        Delete
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </td>
                </tr>
            </React.Fragment>
        )
    }))

    return (
        <>
            <Container
                fluid
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    height: "calc(100vh - 10rem)",
                    padding: 0,
                    animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: "100%",
                        borderRadius: "7px"
                    }}
                    className='position-relative container-table '
                >
                    <TableWrapper
                        isLoading={isLoading}
                        hasData={hasDataToDisplay}
                        tableHeader={tableHeader()}
                        tableBody={tableBody()}
                        displayStartItem={displayStartItem}
                        displayEndItem={displayEndItem}
                        totalItems={totalItems}
                        currPageItems={currPageItems}
                        offset={offset}
                        setOffset={setOffset}
                        limit={limit}
                        setLimit={setLimit}
                        handlePageChange={handlePageChange}
                        effectivePageCount={effectivePageCount}
                        columnLabels={visibleColumnLabels}
                    />
                </div>
            </Container>
            {globalDiller && (
                <GlobalCallModal
                    isOpen={globalDiller}
                    customerId={customer?.customer_details?.customer_id}
                    loginUserId={customer?.customer_details?.id}
                    phoneNumber={callingTo}
                    onClose={handleGlobalCallChange}
                    module_name={"contact"}
                    module_id={module_id}
                />
            )}

            {/* {twilio modal} */}
            {showtwilioModal && (
                <TwilioIntegrationForm
                    isOpen={showtwilioModal}
                    onClose={() => setShowTwilioModal(false)}
                />
            )}

        </>
    )
}

const styles = {
    lastdStyle: {
        padding: "0 !important",
    },
    lastactiontd: {
        padding: "0px !important",
    },
}

